import React, { useCallback, useEffect, useState } from 'react';
import { Text } from '@consta/uikit/Text';
import LogoDrop from 'src/assets/vector.svg';

// Styles
import styles from './styles.styl';
import cn from 'classnames/bind';
import {
  DefaultRatingValue,
  QuestionCreationName,
  QuestionPossibleAnswerName,
  QuestionPossibleAnswerSlider,
  QuestionPossibleAnswertext,
  QuestionScoreTooltipTest,
  QuestionTooltipTextComment,
  QuestionTooltipTextRight,
} from 'src/config/config';
import { TextField } from '@consta/uikit/TextField';
import { DragNDropField } from '@consta/uikit/DragNDropField';
import { Button } from '@consta/uikit/Button';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { Action } from 'redux';
import { loadAddImages } from 'src/redux/features/surveys/addImages/actions';
import {
  addImagesIdSelector,
  addImagesLoadedSelector,
  addImagesPendingSelector,
} from 'src/redux/features/surveys/addImages/selectors';
import { AddImagesSurveysData } from 'src/redux/features/surveys/addImages/types';
import { loadDeleteImagesSurveys } from 'src/redux/features/surveys/deleteImagesSurvey/actions';
import { Select } from '@consta/uikit/Select';
import { Switch } from '@consta/uikit/Switch';
import { IconAdd } from '@consta/uikit/IconAdd';
import { IconTrash } from '@consta/uikit/IconTrash';
import { Theme } from '@consta/uikit/Theme';
import { myPreset } from 'src/utils/myPreset';
import { withTooltip } from '@consta/uikit/withTooltip';
import { IconQuestion } from '@consta/uikit/IconQuestion';
import { IconDraggable } from '@consta/uikit/IconDraggable';
import { Loader } from '@consta/uikit/Loader';
import {
  deleteImagesLoadedSelector,
  deleteImagesPendingSelector,
} from 'src/redux/features/surveys/deleteImagesSurvey/selectors';
import {
  ChangeQuestionAnswerEnum,
  QuestionTypeEnum,
  SurveyStatusEnum,
  SurveyTypeEnum,
} from 'src/utils/enum';
import {
  AddCreateAnswersData,
  AddCreateQuestion,
} from 'src/redux/features/questions/createQuestion/types';
import {
  createQuestionIdle,
  loadAddCreateQuestion,
} from 'src/redux/features/questions/createQuestion/actions';
import {
  addCreateQuestionLoadedSelector,
  addCreateQuestionPendingSelector,
} from 'src/redux/features/questions/createQuestion/selectors';
import { initQuestionSelector } from 'src/redux/selectors';
import { InitSurveyInterface } from 'src/utils/types';
import { userInitLoadedSelector } from 'src/redux/features/userInit/selectors';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { AllListQuestionDataEnt } from 'src/redux/features/questions/allListQuestions/types';
import {
  editQuestionIdle,
  loadEditQuestion,
} from 'src/redux/features/questions/editQuestion/actions';
import { editQuestionLoadedSelector } from 'src/redux/features/questions/editQuestion/selectors';
import { locationNotApi } from 'src/utils/api';
import { TestState } from 'src/redux/features/surveys/testData/types';
import { TitleCreateTestType } from 'src/redux/features/surveys/titleCreateTest/types';
import { ISurvey } from 'src/redux/features/surveys/allSurvey/types';
import { Slider } from '@consta/uikit/SliderCanary';

const cx = cn.bind(styles);

export interface QuestionCreationProps {
  className?: string;
  loadAddImages: (td: any) => void;
  isLoadingAddImages: boolean;
  isPendingAddImages: boolean;
  isPendingDeleteImages: boolean;
  isLoadingDeleteImages: boolean;
  addImages: AddImagesSurveysData;
  loadDeleteImagesSurveys: (id: number) => void;
  loadAddCreateQuestion: (id: number, questions: AddCreateQuestion) => void;
  setQuestion: (isQuest: boolean) => void;
  isLoadedCreateQuestion: boolean;
  isPendingCreateQuestion: boolean;
  createQuestionIdle: () => void;
  initQuestion: InitSurveyInterface[];
  userInitLoaded: boolean;
  editQuestion: AllListQuestionDataEnt | null;
  loadEditQuestion: (
    idSurvey: number,
    idQuestion: number,
    questions: AddCreateQuestion,
  ) => void;
  isLoadedEditQuestion: boolean;
  editQuestionIdle: () => void;
  testData: TestState;
  titleCreateTest: TitleCreateTestType;
  oneSurvey: ISurvey;
  id: string;
}

export const QuestionCreation: React.FC<QuestionCreationProps> = ({
  className,
  loadAddImages,
  isLoadingAddImages,
  isPendingAddImages,
  isPendingDeleteImages,
  isLoadingDeleteImages,
  addImages,
  loadDeleteImagesSurveys,
  loadAddCreateQuestion,
  setQuestion,
  isLoadedCreateQuestion,
  isPendingCreateQuestion,
  createQuestionIdle,
  initQuestion,
  userInitLoaded,
  editQuestion,
  loadEditQuestion,
  isLoadedEditQuestion,
  editQuestionIdle,
  testData,
  oneSurvey,
  id,
}) => {
  const TextWithTooltip = withTooltip()(Text);

  const [name, setName] = useState('');
  const [typeQuest, setTypeQuest] = useState<InitSurveyInterface | null>(null);
  const [isCorrectQuest, setIsCorrectQuest] = useState(false);
  const [isCommentUser, setIsCommentUser] = useState(false);
  const [isReport, setIsReport] = useState(true);
  const [pathImage, setPathImage] = useState(null);
  const [isDisabledSaveButton, setIsDisabledSaveButton] = useState(true);
  const [score, setScore] = useState(0);
  const [isRequired, setIsRequired] = useState(true);
  const [slider, setSlider] = useState<number>(5);

  const [possibleAnswer, setPossibleAnswer] = useState<
    AddCreateAnswersData[] | []
  >([]);

  const testInitQuestion = initQuestion.filter((item) => {
    if (
      item.id === QuestionTypeEnum.SINGLE_AND_SELF ||
      item.id === QuestionTypeEnum.MULTIPLE_AND_SELF
    ) {
      null;
    } else {
      return item;
    }
  });

  useEffect(() => {
    if (editQuestion) {
      const newAnswers = editQuestion.answers.map((item) => ({
        id: item.id,
        is_answer_correct: item.is_answer_correct,
        name: item.name,
      }));
      const correctQuestion = newAnswers.some((item) => item.is_answer_correct);
      const newType = initQuestion.findIndex(
        (item) => item.id === editQuestion.type,
      );
      setName(editQuestion?.name);
      setTypeQuest(initQuestion[newType]);
      setIsCommentUser(editQuestion.is_comment);
      setIsReport(editQuestion?.is_export);
      setIsRequired(editQuestion.is_required);
      setIsCorrectQuest(correctQuestion);
      setPathImage(
        editQuestion.images.length === 0 ? null : editQuestion.images[0],
      );
      setPossibleAnswer(newAnswers);
      setScore(editQuestion?.points);
      setSlider(editQuestion?.rating || DefaultRatingValue);
    } else {
      userInitLoaded && setTypeQuest(initQuestion[0]);
    }
  }, [editQuestion, initQuestion, userInitLoaded]);

  useEffect(() => {
    isLoadingAddImages && setPathImage(addImages);
  }, [addImages, isLoadingAddImages]);

  useEffect(() => {
    isLoadingDeleteImages && setPathImage(null);
  }, [isLoadingDeleteImages]);

  useEffect(() => {
    if (isLoadedCreateQuestion) {
      createQuestionIdle();
      setQuestion(false);
    }
  }, [createQuestionIdle, isLoadedCreateQuestion, setQuestion]);

  useEffect(() => {
    if (isLoadedEditQuestion) {
      editQuestionIdle();
      setQuestion(false);
    }
  }, [editQuestionIdle, isLoadedEditQuestion, setQuestion]);

  useEffect(() => {
    setIsDisabledSaveButton(
      !(
        name &&
        (possibleAnswer.length > 0 ||
          typeQuest?.id === QuestionTypeEnum.POINT_RATING) &&
        possibleAnswer.every((item: AddCreateAnswersData) => item?.name)
      ),
    );
  }, [name, possibleAnswer, typeQuest]);

  const handleFiles = useCallback(
    (file) => {
      const fd = new FormData();
      fd.append('file', file[0]);
      loadAddImages(fd);
    },
    [loadAddImages],
  );

  const handleCorrectQuestion = useCallback(
    (checked: boolean) => {
      if (!checked && possibleAnswer.length > 0) {
        const newPossibleAnswer = [...possibleAnswer];
        newPossibleAnswer.map((item) => {
          item.is_answer_correct = false;
          return item;
        });
        setPossibleAnswer(newPossibleAnswer);
      }
      setIsCorrectQuest((prev) => !prev);
    },
    [possibleAnswer],
  );

  const handleChangeQuestion = useCallback(
    (value) => {
      setTypeQuest(value);
      if (value.id === QuestionTypeEnum.POINT_RATING) {
        setPossibleAnswer([]);
      } else {
        const newPossibleAnswer = [...possibleAnswer];
        newPossibleAnswer.map((item) => {
          item.is_answer_correct = false;
          return item;
        });
        setPossibleAnswer(newPossibleAnswer);
      }
      if (
        value.id === QuestionTypeEnum.SELF_SELECT ||
        value.id === QuestionTypeEnum.POINT_RATING ||
        value.id === QuestionTypeEnum.MULTIPLE_POINT_RATING
      ) {
        setIsCorrectQuest(false);
      }
    },
    [possibleAnswer],
  );

  const handleAddAnswer = useCallback(() => {
    setPossibleAnswer([
      ...possibleAnswer,
      { name: '', is_answer_correct: false },
    ]);
  }, [possibleAnswer]);

  const handleDeleteAnswer = useCallback(
    (i: number) => {
      const newPossibleAnswer = possibleAnswer.filter(
        (item: AddCreateAnswersData, index: number) => {
          if (index !== i) {
            return item;
          }
        },
      );
      setPossibleAnswer(newPossibleAnswer);
    },
    [possibleAnswer],
  );

  const handleDelImage = useCallback(() => {
    loadDeleteImagesSurveys(pathImage?.id);
  }, [loadDeleteImagesSurveys, pathImage]);

  const handleChangeAnswer = useCallback(
    (id: string, value, i: number) => {
      const newPossibleAnswer = [...possibleAnswer];
      if (id === ChangeQuestionAnswerEnum.Text) {
        newPossibleAnswer.map((item, index) => {
          if (index === i) {
            item.name = value || '';
            return item;
          } else {
            return item;
          }
        });
      } else if (id === ChangeQuestionAnswerEnum.Select) {
        newPossibleAnswer.map((item, index) => {
          if (index === i) {
            item.is_answer_correct = !item.is_answer_correct;
            return item;
          } else if (
            typeQuest?.id === QuestionTypeEnum.SINGLE_SELECT ||
            typeQuest?.id === QuestionTypeEnum.SINGLE_AND_SELF
          ) {
            item.is_answer_correct = false;
            return item;
          } else {
            return item;
          }
        });
      }
      setPossibleAnswer(newPossibleAnswer);
    },
    [possibleAnswer, typeQuest],
  );

  const handleSaveQuestion = useCallback(() => {
    let newScore: number;
    if (
      testData.type === SurveyTypeEnum.TEST &&
      !possibleAnswer.some((item) => item.is_answer_correct)
    ) {
      newScore = 0;
    } else {
      newScore = score;
    }
    const newSave = {
      name: name,
      type: typeQuest?.id,
      images: pathImage?.id ? [pathImage?.id] : [],
      points:
        testData.type === SurveyTypeEnum.TEST &&
        isCorrectQuest &&
        typeQuest?.id !== QuestionTypeEnum.POINT_RATING &&
        typeQuest?.id !== QuestionTypeEnum.MULTIPLE_POINT_RATING
          ? newScore
          : 0,
      rating:
        typeQuest?.id === QuestionTypeEnum.POINT_RATING ||
        typeQuest?.id === QuestionTypeEnum.MULTIPLE_POINT_RATING
          ? slider
          : null,
      is_comment: isCommentUser,
      is_export: isReport,
      is_required: isRequired,
      answers: possibleAnswer,
    };
    if (editQuestion) {
      loadEditQuestion(Number(id), editQuestion?.id, newSave);
    } else {
      loadAddCreateQuestion(Number(id), newSave);
    }
  }, [
    editQuestion,
    isCommentUser,
    isReport,
    loadAddCreateQuestion,
    loadEditQuestion,
    name,
    pathImage,
    possibleAnswer,
    typeQuest,
    score,
    isCorrectQuest,
    isRequired,
    testData,
    slider,
    id,
  ]);
  return (
    <div className={cx('QuestionCreation', className)}>
      <div className={cx('QuestionCreation__directTitle')}>
        <Text view="secondary" size="m" display="inline">
          {QuestionCreationName}
        </Text>
        <span className={cx('QuestionCreation__star')}>*</span>
      </div>
      <TextField
        className={cx('QuestionCreation__textField')}
        onChange={({ value }) => {
          setName(value);
        }}
        value={name}
        size="m"
        placeholder="Введите текст"
      />
      <div className={cx('QuestionCreation__drops')}>
        {isPendingAddImages ? (
          <Loader />
        ) : pathImage ? (
          <div className={cx('QuestionCreation__deleteImage')}>
            <img
              className={cx('QuestionCreation__image')}
              src={`${locationNotApi}${pathImage?.path}`}
            />
            <div>
              <Button
                onClick={() => {
                  handleDelImage();
                }}
                className={cx('CloseModal__button')}
                size="s"
                view="clear"
                iconRight={IconTrash}
                disabled={isPendingDeleteImages}
                onlyIcon
              />
            </div>
          </div>
        ) : (
          <DragNDropField
            accept=".jpg,.jpeg,.png"
            onDropFiles={(file) => handleFiles(file)}
          >
            {({ openFileDialog }) => (
              <div className={cx('QuestionCreation__drop')}>
                <img
                  className={cx('QuestionCreation__logoDrop')}
                  src={LogoDrop}
                />
                <div className={cx('QuestionCreation__dropRow')}>
                  <Text
                    className={cx('QuestionCreation__dropText')}
                    view="secondary"
                    size="s"
                  >
                    Перетащите изображения или{' '}
                  </Text>
                  <Button
                    size="s"
                    view="clear"
                    onClick={openFileDialog}
                    label="загрузите"
                    className={cx('QuestionCreation__buttonLoad')}
                  />
                </div>
                <Text
                  className={cx('QuestionCreation__supported')}
                  view="ghost"
                  size="xs"
                >
                  Поддерживаемые форматы: PNG, JPG, JPGEG
                </Text>
              </div>
            )}
          </DragNDropField>
        )}
      </div>
      <div className={cx('QuestionCreation__border')}></div>
      <Select
        placeholder="Выберите тип вопроса"
        name="тип вопроса"
        size="s"
        items={
          testData.type === SurveyTypeEnum.TEST
            ? testInitQuestion
            : initQuestion
        }
        getItemLabel={(item) => item.name}
        value={typeQuest}
        onChange={({ value }) => handleChangeQuestion(value)}
        className={cx('QuestionCreation__select', {
          QuestionCreation__select_disabled:
            (editQuestion && oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
            oneSurvey.status === SurveyStatusEnum.ENDED,
        })}
        disabled={
          (editQuestion && oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
          oneSurvey.status === SurveyStatusEnum.ENDED
        }
      />
      {(typeQuest?.id === QuestionTypeEnum.POINT_RATING ||
        typeQuest?.id === QuestionTypeEnum.MULTIPLE_POINT_RATING) && (
        <div className={cx('QuestionCreation__slider')}>
          <Slider
            view="division"
            step={1}
            label={`Шкала оценки 1-${slider}`}
            onChange={({ value }) => setSlider(value)}
            value={slider}
            max={10}
            min={2}
            range={false}
            disabled={
              (editQuestion &&
                oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
              oneSurvey.status === SurveyStatusEnum.ENDED
            }
          />
        </div>
      )}
      <Theme preset={myPreset}>
        <div className={cx('QuestionCreation__switchReport')}>
          <Switch
            label={'Обязателен к ответу'}
            checked={isRequired}
            onChange={() => setIsRequired((prev) => !prev)}
            disabled={
              (editQuestion &&
                oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
              oneSurvey.status === SurveyStatusEnum.ENDED
            }
          />
        </div>
        {typeQuest?.id !== QuestionTypeEnum.POINT_RATING &&
          typeQuest?.id !== QuestionTypeEnum.MULTIPLE_POINT_RATING && (
            <div className={cx('QuestionCreation__switchReport')}>
              <Switch
                label="Есть правильный ответ"
                disabled={
                  typeQuest?.id === QuestionTypeEnum.SELF_SELECT ||
                  (editQuestion &&
                    oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
                  oneSurvey.status === SurveyStatusEnum.ENDED
                }
                checked={isCorrectQuest}
                onChange={({ checked }) => handleCorrectQuestion(checked)}
              />
            </div>
          )}
        {testData.type === SurveyTypeEnum.TEST &&
          isCorrectQuest &&
          typeQuest?.id !== QuestionTypeEnum.POINT_RATING &&
          typeQuest?.id !== QuestionTypeEnum.MULTIPLE_POINT_RATING && (
            <div className={cx('QuestionCreation__test')}>
              <div className={cx('QuestionCreation__rowTest')}>
                <div className={cx('QuestionCreation__testTitle')}>
                  <Text view="secondary" size="m">
                    {'Количество баллов'}
                  </Text>
                  <span className={cx('QuestionCreation__star')}>*</span>
                </div>
                <Theme preset={myPreset}>
                  <TextWithTooltip
                    lineHeight="s"
                    size="s"
                    tooltipProps={{
                      content: (
                        <div>
                          <Text
                            size="xs"
                            lineHeight="xs"
                            className={cx('QuestionCreation__colorTooltip')}
                          >
                            {QuestionScoreTooltipTest}
                          </Text>
                        </div>
                      ),
                      className: cx('QuestionCreation__colorTooltip'),
                    }}
                  >
                    <IconQuestion
                      className={cx('QuestionCreation__iconQuestion')}
                    />
                  </TextWithTooltip>
                </Theme>
              </div>
              <TextField
                className={cx('QuestionCreation__textFieldScore')}
                onChange={({ value }) => {
                  (!isNaN(Number(value)) || value === null) && setScore(+value);
                }}
                value={String(score)}
                size="m"
                disabled={
                  (editQuestion &&
                    oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
                  oneSurvey.status === SurveyStatusEnum.ENDED
                }
              />
            </div>
          )}
        <div className={cx('QuestionCreation__switch')}>
          <Switch
            label="Комментарий пользователя"
            checked={isCommentUser}
            onChange={() => setIsCommentUser((prev) => !prev)}
            disabled={
              (editQuestion &&
                oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
              oneSurvey.status === SurveyStatusEnum.ENDED
            }
          />
          <TextWithTooltip
            lineHeight="s"
            size="s"
            tooltipProps={{
              content: (
                <div>
                  <Text
                    size="xs"
                    lineHeight="xs"
                    className={cx('QuestionCreation__colorTooltip')}
                  >
                    {QuestionTooltipTextRight}
                  </Text>
                </div>
              ),
              className: cx('QuestionCreation__colorTooltip'),
            }}
          >
            <IconQuestion className={cx('QuestionCreation__iconQuestion')} />
          </TextWithTooltip>
        </div>

        <div className={cx('QuestionCreation__switch')}>
          <Switch
            label="Выгружается в отчет"
            checked={isReport}
            onChange={() => setIsReport((prev) => !prev)}
            disabled={
              (editQuestion &&
                oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
              oneSurvey.status === SurveyStatusEnum.ENDED
            }
          />
          <TextWithTooltip
            lineHeight="s"
            size="s"
            tooltipProps={{
              content: (
                <div>
                  <Text
                    size="xs"
                    lineHeight="xs"
                    className={cx('QuestionCreation__colorTooltip')}
                  >
                    {QuestionTooltipTextComment}
                  </Text>
                </div>
              ),
              className: cx('QuestionCreation__colorTooltip'),
            }}
          >
            <IconQuestion className={cx('QuestionCreation__iconQuestion')} />
          </TextWithTooltip>
        </div>
      </Theme>
      <DragDropContext
        onDragEnd={(param) => {
          const srcI = param.source.index;
          const desI = param.destination?.index;
          if (desI || desI === 0) {
            const newPosAnswer = [...possibleAnswer];
            newPosAnswer.splice(desI, 0, newPosAnswer.splice(srcI, 1)[0]);
            setPossibleAnswer(newPosAnswer);
          }
        }}
      >
        <Droppable droppableId="droppable-2">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {possibleAnswer.map((item, index) => (
                <Draggable
                  key={index}
                  draggableId={`draggable-${index}`}
                  index={index}
                >
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.draggableProps}>
                      <Text
                        className={cx('QuestionCreation__directTitle')}
                        view="secondary"
                        size="m"
                      >
                        {typeQuest?.id === QuestionTypeEnum.SELF_SELECT
                          ? QuestionPossibleAnswerName
                          : typeQuest?.id ===
                            QuestionTypeEnum.MULTIPLE_POINT_RATING
                          ? QuestionPossibleAnswerSlider
                          : QuestionPossibleAnswertext}
                      </Text>
                      <div className={cx('QuestionCreation__possibleAnswer')}>
                        <TextField
                          className={cx('QuestionCreation__textFieldAnswer')}
                          onChange={({ value }) => {
                            handleChangeAnswer(
                              ChangeQuestionAnswerEnum.Text,
                              value,
                              index,
                            );
                          }}
                          value={item.name}
                          size="m"
                          id={`${ChangeQuestionAnswerEnum.Text}${index}`}
                          placeholder={
                            typeQuest?.id === QuestionTypeEnum.SELF_SELECT
                              ? 'Введите название поля'
                              : typeQuest?.id ===
                                QuestionTypeEnum.MULTIPLE_POINT_RATING
                              ? 'Параметр оценки'
                              : 'Введите вариант ответа'
                          }
                        />
                        {isCorrectQuest && (
                          <input
                            className={cx('QuestionCreation__checkbox')}
                            type="checkbox"
                            id="check"
                            checked={item.is_answer_correct}
                            disabled={
                              (editQuestion &&
                                oneSurvey.status ===
                                  SurveyStatusEnum.PUBLISHED) ||
                              oneSurvey.status === SurveyStatusEnum.ENDED
                            }
                            onChange={() =>
                              handleChangeAnswer(
                                ChangeQuestionAnswerEnum.Select,
                                null,
                                index,
                              )
                            }
                          />
                        )}
                        <IconDraggable
                          className={cx('QuestionCreation__drag', {
                            QuestionCreation__drag_hide:
                              (editQuestion &&
                                oneSurvey.status ===
                                  SurveyStatusEnum.PUBLISHED) ||
                              oneSurvey.status === SurveyStatusEnum.ENDED,
                          })}
                          {...provided.dragHandleProps}
                        />
                        {!(
                          (editQuestion &&
                            oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
                          oneSurvey.status === SurveyStatusEnum.ENDED
                        ) && (
                          <Button
                            onClick={() => {
                              handleDeleteAnswer(index);
                            }}
                            className={cx('CloseModal__button')}
                            size="m"
                            view="clear"
                            iconRight={IconTrash}
                            disabled={isPendingDeleteImages}
                            onlyIcon
                          />
                        )}
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {!(
        (editQuestion && oneSurvey.status === SurveyStatusEnum.PUBLISHED) ||
        oneSurvey.status === SurveyStatusEnum.ENDED ||
        typeQuest?.id === QuestionTypeEnum.POINT_RATING
      ) && (
        <Button
          size="m"
          view="clear"
          iconLeft={IconAdd}
          label={
            typeQuest?.id === QuestionTypeEnum.SELF_SELECT
              ? 'Добавить поле для ответа'
              : typeQuest?.id === QuestionTypeEnum.MULTIPLE_POINT_RATING
              ? 'Добавить параметр для оценки'
              : ' Добавить вариант ответа'
          }
          onClick={() => handleAddAnswer()}
          className={cx('QuestionCreation__buttonAdd')}
        />
      )}
      <div className={cx('QuestionCreation__footer')}>
        <Button
          size="m"
          view="secondary"
          label="Отмена"
          onClick={() => setQuestion(false)}
          className={cx('QuestionCreation__close')}
        />
        <Button
          size="m"
          view="primary"
          label="Сохранить"
          disabled={isDisabledSaveButton}
          loading={isPendingCreateQuestion}
          onClick={() => handleSaveQuestion()}
          className={cx('QuestionCreation__close')}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: State, props: any) => ({
  addImages: addImagesIdSelector(state),
  isLoadingAddImages: addImagesLoadedSelector(state, props),
  isPendingAddImages: addImagesPendingSelector(state),
  isLoadingDeleteImages: deleteImagesLoadedSelector(state, props),
  isPendingDeleteImages: deleteImagesPendingSelector(state),
  isLoadedCreateQuestion: addCreateQuestionLoadedSelector(state, props),
  isPendingCreateQuestion: addCreateQuestionPendingSelector(state),
  initQuestion: initQuestionSelector(state),
  userInitLoaded: userInitLoadedSelector(state, props),
  isLoadedEditQuestion: editQuestionLoadedSelector(state, props),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<State, void, Action>) => ({
  loadAddImages: (td: any) => dispatch(loadAddImages(td)),
  loadDeleteImagesSurveys: (id: number) =>
    dispatch(loadDeleteImagesSurveys(id)),
  loadAddCreateQuestion: (id: number, questions: AddCreateQuestion) =>
    dispatch(loadAddCreateQuestion(id, questions)),
  createQuestionIdle: () => dispatch(createQuestionIdle()),
  loadEditQuestion: (
    idSurvey: number,
    idQuestion: number,
    questions: AddCreateQuestion,
  ) => dispatch(loadEditQuestion(idSurvey, idQuestion, questions)),
  editQuestionIdle: () => dispatch(editQuestionIdle()),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionCreation);
